// SPDX-License-Identifier: LGPL-3.0-or-later
export const _asyncFSKeys = [
    'rename',
    'stat',
    'touch',
    'createFile',
    'unlink',
    'rmdir',
    'mkdir',
    'readdir',
    'exists',
    'link',
    'sync',
    'read',
    'write',
];
